import { Routes } from '../../constants'
import { nonSelectedEstate } from '../../reducers/app'
import { EstateUtils } from '../../utils'

/**
 * Gets default estate
 * @param {Array<Object>} estates estates list
 * @param {String} selectedEstate
 */
function getDefaultEstate(estates, selectedEstate) {
    const computeDefaultEstate = () => {
        // If not, take the estate with lowest order from the estates list
        const estateSort = (estate1 = {}, estate2 = {}) => {
            const { order: o1 } = estate1
            const { order: o2 } = estate2
            return o1 - o2
        }

        // Sort the list and take the id of the first one
        const { id } = estates.sort(estateSort)[0] || {}
        return id
    }
    return selectedEstate && selectedEstate !== nonSelectedEstate && selectedEstate !== Routes.ESTATE_KEY ? selectedEstate : computeDefaultEstate()
}

/**
 * Get estate form url param
 * @param {Object} props Private route props
 */
function getUrlEstate(props) {
    const { computedMatch } = props
    const { params } = computedMatch || {}
    const { estate } = params || {}
    return estate || ''
}

function shouldRenderWithIframe(props) {
    const { currentEstate } = props
    const { url, urlWebsite } = currentEstate || {}
    return currentEstate && url === 'IFRAME' && !!urlWebsite
}

function urlNeedsFormatting(props) {
    const urlEstate = getUrlEstate(props)
    return urlEstate === Routes.ESTATE_KEY
}

function isValidEstateUrl(props) {
    const urlEstate = getUrlEstate(props)
    return !!urlEstate && !urlNeedsFormatting(props) && EstateUtils.isValidEstate(urlEstate)
}

export { getDefaultEstate, getUrlEstate, isValidEstateUrl, shouldRenderWithIframe, urlNeedsFormatting }
